
/**
 * Map / 配列 / オブジェクトを再帰的にたどり、すべての Map をプレーンな Object に変換する。
 * JSON.stringify は Map を {} にしてしまうため、送信前にこの関数で平坦化する。
 * プリミティブや null、Date などはそのまま返す。
 */
export const deepMapToObject = (value: any): any => {
    if (value instanceof Map) {
        const obj: Record<string, any> = {}
        for (const [k, v] of value.entries()) {
            obj[String(k)] = deepMapToObject(v)
        }
        return obj
    }
    if (Array.isArray(value)) {
        return value.map(deepMapToObject)
    }
    // プレーンオブジェクトのみ再帰する（Date などのクラスインスタンスはそのまま）
    if (value !== null && typeof value === 'object' && Object.getPrototypeOf(value) === Object.prototype) {
        const obj: Record<string, any> = {}
        for (const [k, v] of Object.entries(value)) {
            obj[k] = deepMapToObject(v)
        }
        return obj
    }
    return value
}

export const buildDefaultArgs = (schema: any): Map<string, any> => {
    const props = schema?.properties ?? {}
    const defaults: Map<string, any> = new Map()
    for (const [k, v] of Object.entries(props) as [string, any][]) {
        if (v.default !== undefined) defaults.set(k, v.default)
        else if (v.type === 'boolean') defaults.set(k, false)
        else if (v.type === 'integer' || v.type === 'number') defaults.set(k, 0)
        else if (v.enum) defaults.set(k, v.enum[0])
        else defaults.set(k, "")
    }
    return defaults
}